<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter

    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template >
    <footer class="the-footer flex items-center justify-between" :class="classes">
        <div>
          <slot class="">
            <div></div>
          </slot>
          <slot name="block2"></slot>
        </div>

        <span class="md:flex hidden items-center">
          <p class="mr-2 cursor-pointer text-dark" @click="loginAction" v-if="$store.getters.userInfo.isAnonymous">You are not registered yet, <span class="font-semibold">sign up to not lose your dreams</span>.</p>
          <img src="/improvee_logo_light.svg" v-if="$store.getters.theme === 'dark'" class="flex-1 fill-current text-primary" height="28" />

          <img src="/improvee_logo.svg" v-else class="flex-1 fill-current text-primary" height="24" />
            <!-- <span>May you achieve what you aspire and may all your dreams come true</span> -->
            <!-- <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" /> -->
        </span>
    </footer>
</template>
q
<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    },
    loginAction: {
      type: Function
    }
  },
}
</script>
